<template>
    <div class="breadcrumbs">
        <v-layout wrap align-center>
            <v-flex xs12 sm12 md9 lg9 xl9>
                <h2 class="page-before-breadcrumb">{{ currentPage }} |</h2>
                <v-btn flat icon class="home-breadcrumb" color="primary" to="/">
                    <v-icon>home</v-icon>
                </v-btn>
                <p class="home-breadcrumb-divider">>></p>
                <v-breadcrumbs :items="items" divider=">>"></v-breadcrumbs>
            </v-flex>
            <v-flex class="hidden-sm-and-down" text-xs-right md3 lg3 xl3>
                <v-btn v-if="showAddBtn" depressed to="/upload" class="white--text add-image-btn text-none"
                       color="rgb(135,95,250)">Add Images
                </v-btn>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    export default {
        props: ['currentPage', 'items', 'showAddBtn'],
    }
</script>

<style>

    .breadcrumbs{
        padding:1.5rem 0;
    }
    .page-before-breadcrumb {
        float: left;
        padding: 12px 0;
    }

    .home-breadcrumb {
        float: left;
        margin: 10px 0 10px 10px !important;
        font-size: 22px !important;
    }

    .home-breadcrumb-divider {
        float: left;
        margin: 0;
        padding: 18px 0 18px 4px;
        color: rgba(0, 0, 0, 0.38);
    }

    .add-image-btn{
       font-weight: bold !important;
        margin: 0 !important;
    }
</style>
